<template>
<div>
	<div class="row">
        <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-xs-12">
		    <card class="card" :title="isNew ? 'Add employee' : 'Edit employee'">
                <loader :loading="loading_employee">
					<form @submit.prevent v-if="!loading_employee">
						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="First name"
										placeholder="First name"
										:class="{'has-error':$v.employee.first_name.$error}"
										v-model="$v.employee.first_name.$model">
								</fg-input>
							</div>
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Last name"
										placeholder="Last name"
										:class="{'has-error':$v.employee.last_name.$error}"
										v-model="$v.employee.last_name.$model">
								</fg-input>
							</div>
						</div>

						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Telephone"
										placeholder="Telephone"
										:class="{'has-error':$v.employee.telephone_number.$error}"
										v-model="$v.employee.telephone_number.$model">
								</fg-input>
							</div>
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Veichle number"
										placeholder="Veichle number"
										:class="{'has-error':$v.employee.veichle_number.$error}"
										v-model="$v.employee.veichle_number.$model">
								</fg-input>
							</div>
						</div>

						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<fg-input type="text"
										label="Slots"
										placeholder="Slots"
										:class="{'has-error':$v.employee.slots.$error}"
										v-model="$v.employee.slots.$model">
								</fg-input>
							</div>
							<div class="col-xl-6 col-lg-6">
								<label>Default helper</label>
								<select class="form-control" v-model="$v.employee.id_helper_employee.$model">
									<option :value="null">Nobody</option>
									<option v-for="h in helpers" :value="h.id_employee" :key="h.id_employee" v-if="h.enabled==1">
										{{h.first_name+' '+h.last_name}}
										<!--<template v-if="h.used_for.length>0"> - n/a</template>-->
									</option>
								</select>
								<small>{{isDefaultFor}}</small>
							</div>
						</div>

						<div class="row">
							<div class="col-xl-6 col-lg-6">
								<label>Enabled</label>
								<select class="form-control" v-model="$v.employee.enabled.$model">
									<option :value="1">Yes</option>
									<option :value="0">No</option>
								</select>
							</div>
						</div>

						<div>
  							<label>Departments</label>
  							<multiselect @select="onInsertDepartment" @remove="onRemoveDepartment" v-model="$v.employee.departments.$model" tag-placeholder="Add departments" placeholder="Add departments" label="name" track-by="id_department" :options="departments" :multiple="true" :taggable="true" :searchable="false"></multiselect>
						</div>
			
						<template name="footer">
							<div class="row mt-4">
								<div class="col-4 text-left">
									<router-link to="/employees">
										<p-button  type="link" round>
										Back
										</p-button>
									</router-link>
								</div>
								<div class="col-8 text-right">
									<p-button v-if="isNew || (!isNew && isModified)" :loading="loading_save || $v.employee.$pending" type="success"
											round
											@click.native.prevent="saveEmployee">
									Save
									</p-button>
									<p-button v-if="!isNew && !isModified" :loading="loading_delete" type="danger"
											round
											@click.native.prevent="deleteEmployee">
									Delete
									</p-button>
								</div>
							</div>
						</template>
			
		        	</form>
				</loader>
		  	    
		    </card>
	    </div>

	</div>

</div>
</template>
<script>

import {required,numeric} from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';

export default {
	components:{
		Multiselect
	},
  	data(){
		return{
			employee:{},
			helpers:[],
			departments:[],
			departments_delete:[],
			loading_employee:false,
			loading_save:false,
			loading_delete:false,
		}
  	},
  	validations:{
		employee:{
            first_name:{required},
			last_name:{required},
			telephone_number:{},
			veichle_number:{},
			slots:{required,numeric},
			id_helper_employee:{},
			enabled:{required},
			departments:{required}
	  	}
  	},
	computed:{
		isNew(){
			return this.$route.params.id_employee==='new'; 
		},
		isModified(){
			return this.$v.employee.$anyDirty;
		},
		idEmployee(){
			return this.$route.params.id_employee;
		},
		isDefaultFor(){
			if(this.employee.id_helper_employee!==null){
				let found = this.helpers.find(h=>{
					return h.id_employee === this.employee.id_helper_employee
				});
				if(found.used_for.length>0){
					let str = 'Default for: ';
					for(let i=0;i<found.used_for.length;i++){
						str += found.used_for[i].first_name+' '+found.used_for[i].last_name
						if(i!==found.used_for.length-1){
							str+=', '
						}
					}
					return str
				}
			}
		}
	},
  	methods:{
		/*helpers */
		async loadHelpers(){
			let result = await this.$api.get('employee?where=id_employee!='+this.idEmployee);
			this.helpers = result.data;
			/*let used_helper = [];
			this.helpers.forEach(h => {
				if(h.id_helper_employee!==null){
					used_helper.push(h.id_helper_employee)
				}
			});

			for(let i=0;i<this.helpers.length;i++){
				if(used_helper.includes(this.helpers[i].id_employee)){
					this.$set(this.helpers[i],'used',true);
					let used_for = await this.$api.get('employee?where=id_helper_employee='+this.helpers[i].id_employee);
					this.$set(this.helpers[i],'used_for',used_for.data);
				}
				else{
					this.$set(this.helpers[i],'used',false);
					this.$set(this.helpers[i],'used_for',[]);
				}
			}*/
			for(let i=0;i<this.helpers.length;i++){
				let used_for = await this.$api.get('employee?where=id_helper_employee='+this.helpers[i].id_employee);
				this.$set(this.helpers[i],'used_for',used_for.data);
			}
		},

		/*departments */
		async loadDepartments(){
			let result = await this.$api.get('department');
			this.departments = result.data;
		},
		onRemoveDepartment(removedOption, id){
			this.departments_delete.push(removedOption.id_department);
		},
		onInsertDepartment(selectedOption, id){
			var index = this.departments_delete.indexOf(selectedOption.id_department);
			if(index>-1){
				this.departments_delete.splice(index, 1);
			}
		},

	/*employee*/
	async loadEmployee(){
	  if(this.isNew){
		let result = {
		  data:{
			id_employee:null,
            first_name:null,
			last_name:null,
			telephone_number:null,
			veichle_number:null,
			slots:null,
			id_helper_employee:null,
			enabled:1,
			departments:null
		  }
		}
		this.employee = result.data;
	  }
	  else{
		let result = await this.$api.get('employee/'+this.idEmployee+'?join=departments');
		this.employee = result.data;
	  }
	},
	async saveEmployee(){
		this.$v.employee.$touch();
		this.loading_save = true;

		if(!this.$v.employee.$invalid){
			if(this.isNew){
				let result = await this.$api.post('employee',this.employee);
				this.employee.id_employee = result.data.id_employee;
			}
			else{
				let result = await this.$api.put('employee/'+this.idEmployee,this.employee);
			}

			for(let i=0;i<this.departments_delete.length;i++){
				await this.$api.delete('employee/'+this.employee.id_employee+'/department/'+this.departments_delete[i]);
			}

			for(let i=0;i<this.employee.departments.length;i++){
				await this.$api.post('employee/'+this.employee.id_employee+'/department/'+this.employee.departments[i].id_department);
			}

			this.$toast.success({
				message:this.isNew ? 'employee added' : 'employee edited',
				icon: "ti-check"
			});
			if(this.isNew){
				this.$router.push({path:'/employees/'+this.employee.id_employee});
			}
			this.$v.employee.$reset();
		}
		else{
			this.$toast.error({
				message:'Some fields must be completed',
				icon: "ti-face-sad"
			});			
		}
		
		this.loading_save = false;
	},
	async deleteEmployee(){
		try{
			this.loading_delete = true;
			await this.$api.delete('employee/'+this.idEmployee);
			this.loading_delete = false;
			this.$toast.error({
				message:'employee deleted',
				icon: "ti-check"
			});
			this.$router.push({path:'/employees'});
		}
		catch(error){
			this.loading_delete = false;
			this.$toast.warning({
				message:'Not possible to delete this employee',
				icon: "ti-alert",
			})
		}
    },
  },
  async beforeMount(){
	this.loading_employee = true;
	await this.loadEmployee();
	await this.loadHelpers();
	await this.loadDepartments();
	this.loading_employee = false;
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
